import { useQuery } from "react-query";
import endpoints from "./EndPoints"
import { getCompanyList } from "./Services";






export const useGetCompanies= () => {
  return useQuery([endpoints.getCompanies], () => getCompanyList(), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};


